module.exports = __webpack_public_path__ + "static/media/018.407c6325.jpg";